export default "__VITE_ASSET__DSr6te97__"